import { cabinetProductsActions } from '../actions'

const {
  FETCHING_CABINET_PRODUCTS,
  FETCH_CABINET_PRODUCTS,
  FETCH_CABINET_PRODUCTS_ERROR
} = cabinetProductsActions

const initialState = {
  loading: {
    cabinet: false,
  },
  fetch_errors: {
    cabinet: false,
  },
  cabinet: {
    id: 0,
    name: '',
    cabinet_products: [],
    updated_at: ''
  }
}

const cabinetProducts = (state = initialState, action = '') => {
  switch (action.type) {
    case FETCHING_CABINET_PRODUCTS:
      return {
        ...state,
        loading: {
          ...state.loading,
          cabinet: true
        },
        fetch_errors: {
          ...state.fetch_errors,
          cabinet: false
        }
      }

    case FETCH_CABINET_PRODUCTS:
      return {
        ...state,
        cabinet: action.cabinet,
        loading: {
          ...state.loading,
          cabinet: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          cabinet: false
        }
      }

    case FETCH_CABINET_PRODUCTS_ERROR:
      return {
        ...state,
        loading: {
          ...state.loading,
          cabinet: false
        },
        fetch_errors: {
          cabinet: true
        }
      }
    default:
      return state
  }
}

export default cabinetProducts



// WEBPACK FOOTER //
// ./src/reducers/cabinetProducts.js